import { createFileRoute } from "@tanstack/react-router";
import landingCss from "../landing.css?url";
import legalCss from "../legal.css?url";
import { LegalPage } from "../legal/LegalPage";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service - Salesko" },
      {
        name: "description",
        content: "The terms governing your access to and use of the Salesko web workspace, agent integrations, and related services."
      },
      { property: "og:title", content: "Salesko - Terms of Service" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://salesko.ai/terms" }
    ],
    links: [
      { rel: "canonical", href: "https://salesko.ai/terms" },
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
      },
      { rel: "stylesheet", href: landingCss },
      { rel: "stylesheet", href: legalCss }
    ]
  }),
  component: () => <LegalPage doc="terms" />
});
